import React from 'react';

import './index.less';

export enum LoadStatus {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  LOADING_WITH_CONTENT = 'LOADING_WITH_CONTENT',
}

type ChildremItem = JSX.Element | string | JSX.Element[] | null;

interface LoadPlaceholderProps {
  children: ChildremItem | ChildremItem[];
  className?: string;
  id?: string;
  wrapClassName?: string;
  // 加载状态
  loadStatus: LoadStatus;
  // 加载文案
  loadingText?: string;
  // 失败文案
  failureText?: string;
  // 自定义渲染loading
  renderLoadingElement?: () => JSX.Element;
  // 点击重试方法
  onRetry?: () => void;
  // 自定义渲染失败ui
  renderFailureElement?: () => JSX.Element;
  // 自定义渲染loading ui
  renderLoading?: () => JSX.Element;
}

export default class LoadPlaceholder extends React.Component<LoadPlaceholderProps> {
  onClickRetry() {
    const { onRetry } = this.props;
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  }

  renderLoadingIcon() {
    const { loadingText, renderLoadingElement } = this.props;
    if (renderLoadingElement) {
      return renderLoadingElement();
    }
    return (
      <div className="loading-wrapper">
        <div className="circle" />
        <p className="loading-text">{loadingText || '加载中...'}</p>
      </div>
    );
  }

  renderLoadWithContent() {
    const { children } = this.props;
    return children;
  }

  renderLoading() {
    const { className = '', renderLoading } = this.props;
    return (
      <div className={`share-cpn-load ${className}`}>{renderLoading ? renderLoading() : this.renderLoadingIcon()}</div>
    );
  }

  renderFailure() {
    const { renderFailureElement, failureText, className = '' } = this.props;
    return (
      <div
        className={`share-cpn-load ${className}`}
        onClick={() => {
          this.onClickRetry();
        }}
      >
        <div className="failure-wrapper">
          {renderFailureElement ? (
            renderFailureElement()
          ) : (
            <p className="failure-text">{failureText || '加载失败，请点击重试'}</p>
          )}
        </div>
      </div>
    );
  }

  renderContent() {
    const { loadStatus, children } = this.props;
    if (loadStatus === LoadStatus.INITIAL || loadStatus === LoadStatus.LOADING) {
      return this.renderLoading();
    }
    if (loadStatus === LoadStatus.LOADING_WITH_CONTENT) {
      return this.renderLoadWithContent();
    }
    if (loadStatus === LoadStatus.SUCCESS) {
      return children;
    }
    if (loadStatus === LoadStatus.FAILURE) {
      return this.renderFailure();
    }
  }

  render() {
    const { loadStatus, wrapClassName = '', id = '' } = this.props;
    return (
      <div id={id} className={`share-load-wrap ${wrapClassName} ${loadStatus}`}>
        {this.renderContent()}
      </div>
    );
  }
}
